export const displayAds = gpt_id => {

  if (window.googletag) {
    window.googletag.cmd.push(function() { window.googletag.display(gpt_id); });
  }
}
